import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
// import './index.css'
import CssBaseline from "@mui/material/CssBaseline"
// import { ThemeProvider } from '@mui/material/styles'
// import theme from './layouts/Theme'
import "@fontsource/roboto/300.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/500.css"
import "@fontsource/roboto/700.css"
import { BrowserRouter } from "react-router-dom"
import { AuthProvider } from "./contexts/AuthContext"
import { UserLocationProvider } from "./contexts/UserLocationContext"
import { disableReactDevTools } from "@fvilers/disable-react-devtools"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { ThemeModeProvider } from "./contexts/ThemeContext"

const PRODUCTION = process.env.NODE_ENV === "production"
if (PRODUCTION) {
    disableReactDevTools()
}

// Create a client
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 1000, // 5 seconds
        },
    },
})

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
    <React.StrictMode>
        <ThemeModeProvider>
            <BrowserRouter
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true,
                }}
            >
                <CssBaseline enableColorScheme />
                <AuthProvider>
                    <UserLocationProvider>
                        <QueryClientProvider client={queryClient}>
                            <App />
                            <ReactQueryDevtools initialIsOpen={false} />
                            <ToastContainer
                                position="top-right"
                                hideProgressBar={false}
                                closeOnClick
                                pauseOnHover
                            />
                        </QueryClientProvider>
                    </UserLocationProvider>
                </AuthProvider>
            </BrowserRouter>
        </ThemeModeProvider>
    </React.StrictMode>
)
